// extracted by mini-css-extract-plugin
export var aboveInput = "_el-0";
export var actionButton = "_el-5";
export var actionButtonContainer = "_el-1";
export var actionIcon = "_el-6";
export var aiInfoContainer = "_el-2";
export var attachmentWrapper = "_el-7";
export var bold = "_el-3";
export var checkIcon = "_el-8";
export var clickingRecipientBar = "_el-11";
export var commentThreadSwitch = "_el-a";
export var draftImage = "_el-b";
export var draftImageContainer = "_el-c";
export var draftImages = "_el-e";
export var editButton = "_el-g";
export var editor = "_el-f";
export var editorContainer = "_el-y";
export var editorErrorTooltipWrapper = "_el-9";
export var headerDivider = "_el-h";
export var icon = "_el-i";
export var info = "_el-j";
export var internal = "_el-n";
export var internalDivider = "_el-k";
export var internalMessage = "_el-l";
export var messageInputCard = "_el-m";
export var messageInputForm = "_el-o";
export var messageInputFormInternal = "_el-p";
export var options = "_el-q";
export var publicMessageCustomer = "_el-s";
export var publicMessageMerchant = "_el-r";
export var removeImageButton = "_el-d";
export var replyButtons = "_el-t";
export var showSignatureButton = "_el-u";
export var spinner = "_el-v";
export var verticalButtonDivider = "_el-4";
export var visibilitySelector = "_el-w";
export var warning = "_el-x";
export var wrappingText = "_el-z";
export var writingInternalNoteTopBorder = "_el-10";